module.exports = __webpack_public_path__ + "img/delos-logo.51d74a27.svg";